export default "__VITE_PUBLIC_ASSET__dfc1abcc__"